module.exports = __webpack_public_path__ + "static/media/file-xls.1d1b45e6.svg";